const generalRoutes = {
  index: {
    path: 'index.setting.general',
    url: '/general',
  },
}

export default generalRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/general/routes.js